module.exports = __webpack_public_path__ + "media/images/icon-close-white@3x-423f26f1dcbec72380e60bd6dddd70c7.png";